module.exports = __webpack_public_path__ + "static/media/BNB_MDEX_MDEX.77821247.png";